const E="notifier";export{E as NOTIFIER_REDUCER_NAME};
